
function DesktopTop() {
    return (
        <div className={"pw bg-black bg-opacity-10 w-full mx-auto mb-8"}>
            <div id="desktop-top-leaderboard" className="pw-ph-leaderboard" />
        </div>
    )
}

export default DesktopTop;